import React, { useState } from 'react';
import { InformationCircleIcon, ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';

export const TemplateVariablesInfo: React.FC = () => {
  const [isExpanded, setIsExpanded] = useState(true);

  // Parse the variables from the help content
  const variables = [
    { tag: '{{first_name}}', description: "Contact's first name" },
    { tag: '{{last_name}}', description: "Contact's last name" },
    { tag: '{{email}}', description: "Contact's email address" },
    { tag: '{{company}}', description: "Contact's company name" },
    { tag: '{{rating_url}}', description: 'Link to rating page (for campaigns)' },
  ];

  const example = "Hi {{first_name}}, we'd love to hear about your experience with {{company}}!";

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg overflow-hidden">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full px-4 py-3 flex items-center justify-between hover:bg-blue-100 transition-colors"
      >
        <div className="flex items-center gap-2">
          <InformationCircleIcon className="h-5 w-5 text-blue-600" />
          <h3 className="text-sm font-semibold text-blue-900">Available Template Tags</h3>
        </div>
        {isExpanded ? (
          <ChevronUpIcon className="h-5 w-5 text-blue-600" />
        ) : (
          <ChevronDownIcon className="h-5 w-5 text-blue-600" />
        )}
      </button>

      {isExpanded && (
        <div className="px-4 pb-4 space-y-4 border-t border-blue-200">
          {/* Variables Grid */}
          <div className="pt-4">
            <h4 className="text-sm font-medium text-blue-900 mb-3">Available Variables:</h4>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
              {variables.map((variable) => (
                <div
                  key={variable.tag}
                  className="bg-white rounded-md p-3 border border-blue-100 hover:border-blue-300 transition-colors"
                >
                  <code className="text-sm font-mono font-semibold text-indigo-600 block mb-1">
                    {variable.tag}
                  </code>
                  <p className="text-xs text-gray-600">{variable.description}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Example */}
          <div className="pt-2">
            <h4 className="text-sm font-medium text-blue-900 mb-2">Example:</h4>
            <div className="bg-white rounded-md p-3 border border-blue-100">
              <p className="text-sm text-gray-700 font-mono">{example}</p>
            </div>
          </div>

          {/* Quick Tips */}
          <div className="pt-2">
            <h4 className="text-sm font-medium text-blue-900 mb-2">Quick Tips:</h4>
            <ul className="space-y-1.5">
              <li className="text-xs text-gray-700 flex items-start gap-2">
                <span className="text-blue-600 mt-0.5">•</span>
                <span>Always use <code className="font-mono text-indigo-600">{'{{first_name}}'}</code> for personalization</span>
              </li>
              <li className="text-xs text-gray-700 flex items-start gap-2">
                <span className="text-blue-600 mt-0.5">•</span>
                <span>Test templates with sample data before sending</span>
              </li>
              <li className="text-xs text-gray-700 flex items-start gap-2">
                <span className="text-blue-600 mt-0.5">•</span>
                <span>Keep messages concise and clear</span>
              </li>
              <li className="text-xs text-gray-700 flex items-start gap-2">
                <span className="text-blue-600 mt-0.5">•</span>
                <span>Include a clear call-to-action</span>
              </li>
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

